export default class ResultChecker{

}